<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.8001 2.3999C1.1371 2.3999 0.600098 2.9369 0.600098 3.5999V11.9999C0.600098 12.6629 1.1371 13.1999 1.8001 13.1999H2.4001V5.3999C2.4001 4.7369 2.9371 4.1999 3.6001 4.1999H14.4001V3.5999C14.4001 2.9369 13.8631 2.3999 13.2001 2.3999H1.8001ZM4.8001 5.3999C4.1371 5.3999 3.6001 5.9369 3.6001 6.5999V14.3999C3.6001 15.0629 4.1371 15.5999 4.8001 15.5999H16.2001C16.8631 15.5999 17.4001 15.0629 17.4001 14.3999V6.5999C17.4001 5.9369 16.8631 5.3999 16.2001 5.3999H4.8001Z" fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGAdminProjects"
    }
</script>

<style scoped>

</style>
